import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { checkUserAuth } from "../redux/slices/authSlice";

const LoggedInRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.user.authToken);
  const userData = useSelector((state) => state.user.userData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let location = useLocation();
  
  useEffect(() => {
    // If user is authenticated and at the dashboard route, redirect to systemUsageDetailPage
    if (isAuthenticated && userData && (location.pathname === "/dashboard" || location.pathname === "/")) {
      navigate("/systemUsageReports");
    }
  }, [isAuthenticated, userData, location.pathname, navigate]);

  if (isAuthenticated == null || userData == null) {
    dispatch(checkUserAuth());
    // Redirect them to the /dashboard page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" state={{ from: location }} />;
  }
  
  return children;
};

export default LoggedInRoute;
